/**
 * Created by r4zi4l on 25.01.2022
 */

const Map2dAdviceFieldLogic = function (options) {
    options = options || {};

    Map2dAdviceBaseLogic.call(this, options);

    this.action = options.action;
};

Map2dAdviceFieldLogic.prototype = Object.create(Map2dAdviceBaseLogic.prototype);
Map2dAdviceFieldLogic.prototype.constructor = Map2dAdviceFieldLogic;

Map2dAdviceFieldLogic.prototype.getShowHintTimeout = function (move) {
    const steps = move && move.resources && move.resources.length || 0;
    return Map2dAdvice.ONE_ITERATION_DURATION + 300 * steps;
};

Map2dAdviceFieldLogic.prototype.findMove = function () {
    const used = {};
    let clusters = [];

    let units = this.listAvailableUnits().filter((unit) => unit.findComponent(FieldComponent));

    if (this.action) {
        units = units.filter(function (unit) {
            const info = unit.getActionInfo();
            return info && info.actions && info.actions.some(function (action) {
                return action.type === this.action.type;
            }, this);
        }, this);
    }

    units.forEach(function (unit) {
        const key = Unit.GetPositionKey(unit);

        if (!used[key]) {
            const selectedUnits = Map2d.currentMap.bfs(unit.x, unit.y, this.compareUnits.bind(this, unit)).map((cell) => Map2d.currentMap.getUnit(cell.x, cell.y));
            selectedUnits.forEach((selectedUnit) => {
                used[Unit.GetPositionKey(selectedUnit)] = true;
            });
            clusters.push({
                priority: this.calcPriority(selectedUnits),
                units: selectedUnits
            });
        }
    }, this);

    clusters = clusters.filter((cluster) => cluster.priority > 0);

    if (clusters.length) {
        clusters.sort((a, b) => b.priority - a.priority || b.length - a.length);

        const selected = clusters[0].units;
        if (selected.length) {
            selected.sort((a, b) => Number(InfoView.IsDisplayedFor(b)) - Number(InfoView.IsDisplayedFor(a)) || a.x - b.x || a.y - b.y);

            const distance = function (a, b) {
                return Math.abs(a.x - b.x) + Math.abs(a.y - b.y);
            };

            for (let i = 0; i < selected.length - 1; ++i) {
                let j;
                for (j = i + 1; j < selected.length; ++j) {
                    if (distance(selected[i], selected[j]) <= 1) {
                        const tmp = selected[i + 1];
                        selected[i + 1] = selected[j];
                        selected[j] = tmp;
                        break;
                    }
                }
                if (j === selected.length) {
                    selected.length = i + 1;
                    break;
                }
            }

            const infoOpen = InfoView.IsDisplayedFor(selected[0]);
            return {
                cells: [selected[0]],
                highlight: !infoOpen && [selected[0]],
                arrow: !infoOpen && selected[0],
                unitView: infoOpen && Map2d.SPAWN,
                resources: infoOpen && selected
            };
        }
    }
};

Map2dAdviceFieldLogic.prototype.calcPriority = function (units) {
    if (units.some((unit) => InfoView.IsDisplayedFor(unit))) {
        return 3;
    }

    const state = units[0].findComponent(FieldComponent).getState();
    if (state === FieldComponent.STATE_READY) {
        return 2;
    } if (state === FieldComponent.STATE_EMPTY) {
        return 1;
    }

    return 0;
};

Map2dAdviceFieldLogic.prototype.compareUnits = function (target, x, y) {
    let unit = Map2d.currentMap.getUnit(x, y);

    if (!Unit.Equals(target, unit)) {
        return false;
    }

    target = target.findComponent(FieldComponent);
    unit = unit.findComponent(FieldComponent);
    return target.getState() === unit.getState();
};
